import { render, staticRenderFns } from "./TableVisitors.vue?vue&type=template&id=4007553a&scoped=true&"
import script from "./TableVisitors.vue?vue&type=script&lang=ts&"
export * from "./TableVisitors.vue?vue&type=script&lang=ts&"
import style0 from "./TableVisitors.vue?vue&type=style&index=0&id=4007553a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007553a",
  null
  
)

component.options.__file = "TableVisitors.vue"
export default component.exports